'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./node_modules/gopd/gOPD.js
// module id = 380
// module chunks = 0